
(function fileDownloaderServiceDefinition() {

    'use strict';

    function base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);
        var blob = null;
        
        // IE11 No funciona bien cuando se chunkean los archivos.
        if (window.MSBlobBuilder) {
            var bytes = new Uint8Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                bytes[i] = byteCharacters[i].charCodeAt(0);
            }
            return new Blob([bytes], { type: contentType });
        }
 
        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);
 
            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        } 
 
        try{
            blob = new Blob( byteArrays, {type : contentType});
        }
        catch(e){
            // TypeError old chrome and FF
            window.BlobBuilder = window.BlobBuilder ||
                                 window.WebKitBlobBuilder ||
                                 window.MozBlobBuilder ||
                                 window.MSBlobBuilder;
            if(e.name == 'TypeError' && window.BlobBuilder){
                var bb = new BlobBuilder();
                bb.append(byteArrays);
                blob = bb.getBlob(contentType);
            }
            else if(e.name == "InvalidStateError"){
                // InvalidStateError (tested on FF13 WinXP)
                blob = new Blob(byteArrays, {type : contentType});
            }
            else{
                // We're screwed, blob constructor unsupported entirely  
            }
        }
        return blob;
    }

    angular.module('FileDownloader')
           .service('fileDownloader', ['$q', function fileDowloaderService($q) {

               var octetStreamMime = 'application/octet-stream';

               this.saveAs = function (base64Data, fileName) {

					var blob = base64toBlob(base64Data, octetStreamMime);

					if(blob) {
						window.saveAs(blob, fileName);
						return true;
					} else {
						return false;
					}
               };
			   
               this.download = function (response, fileName) {

					return $q.when(response).then(function(base64Data){
						if(base64Data){
							if(base64Data.data)
								base64Data = base64Data.data;
							
							var blob = base64toBlob(base64Data, octetStreamMime);
							
							if(!blob)
								$q.reject({key:'no_blobs', message:'El navegador no soporta blobs'});

							window.saveAs(blob, fileName);
						} else {
							$q.reject({key:'no_data', message:'base64Data es null'});
						}
					});			   

               };

           }]);

})();